import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import swal from "sweetalert";
import { EyePasswordBtn } from "../../../../common/ui/view/CustomEyePasswordBtn";
import { changeUserPassword } from "../../../../services/userApiService/userService";

export default function ChangePasswordModal({ show, onHide }) {
  const [formData, setFormData] = useState({ new_password: "", confirm_new_password: "" });
  const [errors, setErrors] = useState({});
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const errs = {};
    if (!formData.new_password) {
      errs.new_password = "Password is required";
    } else if (formData.new_password.length < 8) {
      errs.new_password = "Minimum 8 characters";
    } else if (!/(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])/.test(formData.new_password)) {
      errs.new_password = "Must include uppercase, number, and special character";
    }
    if (!formData.confirm_new_password) {
      errs.confirm_new_password = "Please confirm your password";
    } else if (formData.new_password !== formData.confirm_new_password) {
      errs.confirm_new_password = "Passwords do not match";
    }
    return errs;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async () => {
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    try {
      setLoading(true);
      const res = await changeUserPassword(formData);
      swal("Success", res?.data?.message || "Password changed successfully", "success");
      handleClose();
    } catch (err) {
      if (err?.response?.data?.errors) setErrors(err.response.data.errors);
      else swal("Error", err?.response?.data?.message || "Failed to change password", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ new_password: "", confirm_new_password: "" });
    setErrors({});
    setShowNew(false);
    setShowConfirm(false);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="p-4">
        <h5 className="fw-semibold mb-3">Change Password</h5>
        <div className="row">
          {[
            { label: "New Password", name: "new_password", show: showNew, setShow: setShowNew },
            { label: "Confirm Password", name: "confirm_new_password", show: showConfirm, setShow: setShowConfirm },
          ].map(({ label, name, show: showPw, setShow }) => (
            <div key={name} className="col-md-12 mb-3">
              <label className="text-black font-w500">
                {label} <span className="text-danger">*</span>
              </label>
              <div className="password-input-container">
                <Form.Control
                  type={showPw ? "text" : "password"}
                  name={name}
                  value={formData[name]}
                  placeholder={label}
                  onChange={handleChange}
                  isInvalid={!!errors[name]}
                />
                <EyePasswordBtn
                  showPassword={showPw}
                  setShowPassword={setShow}
                  hasError={!!errors[name]}
                />
              </div>
              <Form.Control.Feedback type="invalid" className="d-block text-danger">
                {errors[name]}
              </Form.Control.Feedback>
            </div>
          ))}
        </div>
        <ul className="ps-3 text-muted small mb-4 wrapper_of_account_list">
          <li>At least 8 characters</li>
          <li>One uppercase, one number, one special character</li>
        </ul>
        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button variant="outline-secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? "Changing..." : "Change Password"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
